export function validatePhone(phone: string) : boolean {
  // eslint-disable-next-line no-useless-escape
  // https://www.w3resource.com/javascript/form/phone-no-validation.php
  const phoneFormat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  if (phone && !phone.match(phoneFormat)) {
    return false;
  }

  return true;
}

export function validatePhoneExtension(extension: string) : boolean {
  // eslint-disable-next-line no-useless-escape
  // https://www.w3resource.com/javascript/form/all-numbers.php
  const extentionFormat = /^[0-9]+$/;

  if (extension && !extension.match(extentionFormat)) {
    return false;
  }

  return true;
}
